import actions from "./actions"
import mutations from "./mutations"

export default  {
    namespaced: true,

    state: () => ({ 
        layout: 'app',
        isShowAddOrUpdateModal: false,
        subCategoriesList: [],
        tableColumns: ['category', 'name', 'points', 'action'],
     }),

     mutations: mutations,
     actions: actions,

    getters: { 
        isShowModal(state) {
            return state.isShowAddOrUpdateModal;
        },
     }
  }
